<template>
  <div id="wrap">
    <Header ref="refHeader" />
    <Contents ref="refContents" />
  </div>
</template>

<script>
import Header from "@/layout/mobile/components/Header";
import Contents from "@/layout/mobile/components/Contents";

export default {
  name: "Layout",
  components: {
    Header,
    Contents
  },
  created() {
    // console.log("Created.. Mobile index.vue")
  }
}
</script>


<style>
@import '../../assets/mobile/css/reset.css';
@import '../../assets/mobile/css/common.css';
</style>
